import { css, html, LitElement } from 'lit-element';

import { unsafeHTML } from 'lit-html/directives/unsafe-html';

/**
 * @element math-rendering-element
 */
export class PieMathRenderer extends LitElement {
  static get styles() {
    return [
      css`
        div {
          white-space: initial;
        }
      `,
    ];
  }

  static get properties() {
    return {
      label: { type: Object },
      loading: { type: Boolean },
    };
  }

  constructor() {
    super();

    this.loading = !window.renderMath && !window.isInTestMode;
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    this.renderMath();
  }

  renderMath() {
    if (window.renderMath) {
      // this is a hack and it's used to keep pie-api-live-components v2.3.0 working
      if (!(this.getRootNode() instanceof ShadowRoot)) {
        window.renderMath([this]);
      }
    }
  }

  renderMathIsReady() {
    this.loading = false;
    this.requestUpdate('loading');

    this.renderMath();
  }

  connectedCallback() {
    super.connectedCallback();

    window.addEventListener(
      'renderMathReady',
      this.renderMathIsReady.bind(this)
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    window.removeEventListener(
      'renderMathReady',
      this.renderMathIsReady.bind(this)
    );
  }

  render() {
    return this.label && !this.loading
      ? html`<div>${unsafeHTML(this.label)}</div>`
      : html`<div></div>`;
  }
}
